import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

initScrollReveal(targetElements, defaultProps);
initTiltEffect();

const bootLines = [
  "sudo systemctl start ambition.service",
  "grep -R \"signal\" /var/log/life",
  "nmap -sV curiosity.local",
  "git commit -m \"ship the cleaner version\"",
  "SELECT pattern FROM messy_inputs;",
  "console.log('stay sharp');",
  "printf(\"hello, world\\n\");",
  "echo \"Talk is cheap. Show me the logs.\"",
  "print('less noise, more signal')",
  "python -m this",
  "chmod +x ./next-move",
  "tail -f /var/log/opportunity.log",
  "while true; do learn; done",
  "docker compose up focus",
  "def build_systems(for_fun=True): pass"
];

const streamBootLines = () => {
  const stream = document.getElementById("bootStream");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (!stream || reduceMotion) return;

  const shuffled = [...bootLines].sort(() => Math.random() - 0.5).slice(0, 6);

  shuffled.forEach((line, index) => {
    window.setTimeout(() => {
      const item = document.createElement("li");
      const prompt = document.createElement("b");
      prompt.textContent = "$";
      item.append(prompt, ` ${line}`);
      stream.appendChild(item);
    }, index * 260);
  });
};

streamBootLines();

const featuredSpotifySong = {
  title: "Somnus - Instrumental Version",
  artist: "Yoko Shimomura",
  url: "https://open.spotify.com/track/7fxzqLLTXObxIoTfI3FA0l?si=ce67f14a2bfd4563",
  cover: "https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e02c1a3d757e86b84a5b7a68481"
};

const renderFeaturedSpotifySong = () => {
  const card = document.getElementById("spotifyCard");
  const coverNode = document.getElementById("spotifyCover");
  const trackNode = document.getElementById("spotifyTrack");
  const artistNode = document.getElementById("spotifyArtist");

  if (!card || !trackNode || !artistNode) return;

  trackNode.textContent = featuredSpotifySong.title;
  artistNode.textContent = featuredSpotifySong.artist;
  card.href = featuredSpotifySong.url;

  if (coverNode) {
    coverNode.src = featuredSpotifySong.cover;
    coverNode.alt = `${featuredSpotifySong.title} cover`;
  }
};

renderFeaturedSpotifySong();

const gtaLaunchDate = new Date("2026-11-19T00:00:00-05:00");

const renderGtaCountdown = () => {
  const node = document.getElementById("gtaCountdown");
  if (!node) return;

  const diff = gtaLaunchDate.getTime() - Date.now();

  if (diff <= 0) {
    node.textContent = "It is finally Vice City time.";
    return;
  }

  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);

  node.textContent = `${days}d ${hours}h ${minutes}m`;
};

renderGtaCountdown();
window.setInterval(renderGtaCountdown, 60 * 1000);

const historySubjects = [
  "Roman Empire",
  "Byzantine Empire",
  "Silk Road",
  "Library of Alexandria",
  "Abbasid Caliphate",
  "Mongol Empire",
  "Bronze Age collapse",
  "Hanseatic League",
  "Achaemenid Empire",
  "Song dynasty",
  "Umayyad Caliphate",
  "Ottoman Empire",
  "Indus Valley Civilisation",
  "Battle of Agincourt",
  "Age of Discovery",
  "Republic of Venice",
  "House of Wisdom",
  "Pax Romana",
  "Compound interest",
  "Opportunity cost",
  "Market liquidity",
  "Network effect",
  "Behavioral economics",
  "Game theory",
  "Supply chain management",
  "Risk management",
  "Trade finance",
  "Venture capital",
  "Economies of scale",
  "Business cycle",
  "Porter's five forces analysis",
  "Blue ocean strategy"
];

const fallbackHistory = {
  title: "Roman Empire",
  extract:
    "The Roman Empire still shapes the way people talk about power, cities, law, armies, trade, collapse, and legacy.",
  image:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Colosseum_in_Rome%2C_Italy_-_April_2007.jpg/640px-Colosseum_in_Rome%2C_Italy_-_April_2007.jpg",
  url: "https://en.wikipedia.org/wiki/Roman_Empire"
};

let lastHistorySubject = "";

const pickHistorySubject = () => {
  const options = historySubjects.filter((subject) => subject !== lastHistorySubject);
  const subject = options[Math.floor(Math.random() * options.length)];
  lastHistorySubject = subject;
  return subject;
};

const renderHistorySubject = (entry) => {
  const image = document.getElementById("historyImage");
  const title = document.getElementById("historyTitle");
  const extract = document.getElementById("historyExtract");
  const link = document.getElementById("historyLink");

  if (!image || !title || !extract || !link) return;

  title.textContent = entry.title;
  const starterText =
    entry.extract.length > 260 ? `${entry.extract.slice(0, 257).trim()}...` : entry.extract;

  extract.textContent = starterText;
  link.href = entry.url;
  image.src = entry.image;
  image.alt = `${entry.title} image from Wikipedia`;
};

const loadHistorySubject = async () => {
  const button = document.getElementById("historyRefresh");
  const subject = pickHistorySubject();

  if (button) {
    button.disabled = true;
    button.textContent = "Looking...";
  }

  try {
    const response = await fetch(
      `https://en.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(subject)}`
    );

    if (!response.ok) {
      throw new Error("Wikipedia request failed");
    }

    const data = await response.json();
    renderHistorySubject({
      title: data.title || subject,
      extract: data.extract || fallbackHistory.extract,
      image: data.thumbnail?.source || data.originalimage?.source || fallbackHistory.image,
      url: data.content_urls?.desktop?.page || `https://en.wikipedia.org/wiki/${encodeURIComponent(subject)}`
    });
  } catch (error) {
    renderHistorySubject(fallbackHistory);
  } finally {
    if (button) {
      button.disabled = false;
      button.textContent = "Change subject";
    }
  }
};

document.getElementById("historyRefresh")?.addEventListener("click", loadHistorySubject);
loadHistorySubject();

const decorChatReplies = [
  "Hello! This AI chatbot is meant for decoration purposes only. You don’t want me to waste tokens for nothing, so feel free to ask me directly.",
  "I would answer with great artificial wisdom, but this button is mostly here for the atmosphere. Ask Yousef directly and save the tokens.",
  "Decorative AI reporting in. I look intelligent, but today I am just protecting the token budget. Send the real question to Yousef.",
  "I asked the server for a deep answer, but it said we are on a budget. Yousef will do a better job anyway."
];

const decorChatUsageKey = "0xyousef.decorativeChatUsed";
let yousefGptCountry = "";

const detectDeviceType = () => {
  const ua = navigator.userAgent || "";
  const hasTouch = navigator.maxTouchPoints > 1;

  if (/ipad|tablet|kindle|playbook|silk/i.test(ua)) return "Tablet";
  if (/mobi|iphone|ipod|android.*mobile|windows phone/i.test(ua)) return "Phone";
  if (hasTouch && Math.min(window.innerWidth, window.innerHeight) >= 700) return "Tablet";
  return "Desktop";
};

const loadYousefGptCountry = async () => {
  try {
    const response = await fetch("https://ipapi.co/json/", { cache: "no-store" });
    if (!response.ok) throw new Error("Country lookup failed");

    const data = await response.json();
    const countryName = data.country_name || "";
    const countryCode = data.country_code ? ` (${data.country_code})` : "";
    yousefGptCountry = countryName ? `${countryName}${countryCode}` : data.country || "";
  } catch (error) {
    yousefGptCountry = "Unavailable";
  }
};

loadYousefGptCountry();

const hasDecorChatUsage = () => {
  try {
    return window.sessionStorage?.getItem(decorChatUsageKey);
  } catch (error) {
    return document.documentElement.dataset.decorChatUsed;
  }
};

const setDecorChatUsage = () => {
  document.documentElement.dataset.decorChatUsed = "true";

  try {
    window.sessionStorage?.setItem(decorChatUsageKey, "true");
  } catch (error) {
    // The dataset flag keeps the one-message limit during this page view.
  }
};

const submitYousefGptMessage = async (message) => {
  const formData = new URLSearchParams();
  const createdAt = new Date().toISOString();
  const country = yousefGptCountry || "Pending";
  const deviceType = detectDeviceType();

  formData.append("form-name", "yousefgpt");
  formData.append("message", message);
  formData.append("page", window.location.href);
  formData.append("language", navigator.language || "");
  formData.append("country", country);
  formData.append("deviceType", deviceType);
  formData.append("userAgent", navigator.userAgent || "");
  formData.append("createdAt", createdAt);

  await fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: formData.toString()
  });
};

const appendDecorChatBubble = (container, text, type) => {
  const bubble = document.createElement("p");
  bubble.className = `decor-chat__bubble decor-chat__bubble--${type}`;
  bubble.textContent = text;
  container.appendChild(bubble);
  container.scrollTop = container.scrollHeight;
};

const initDecorChat = () => {
  const widget = document.querySelector("[data-chat-widget]");
  const toggle = document.querySelector("[data-chat-toggle]");
  const close = document.querySelector("[data-chat-close]");
  const panel = document.querySelector("[data-chat-panel]");
  const form = document.querySelector("[data-chat-form]");
  const input = document.querySelector("[data-chat-input]");
  const messages = document.querySelector("[data-chat-messages]");
  const pageInput = document.querySelector("[data-chat-page]");
  const languageInput = document.querySelector("[data-chat-language]");
  const countryInput = document.querySelector("[data-chat-country]");
  const deviceTypeInput = document.querySelector("[data-chat-device-type]");
  const userAgentInput = document.querySelector("[data-chat-user-agent]");
  const createdAtInput = document.querySelector("[data-chat-created-at]");

  if (!widget || !toggle || !panel || !form || !input || !messages) return;

  const setOpen = (isOpen) => {
    panel.hidden = !isOpen;
    toggle.setAttribute("aria-expanded", String(isOpen));
    if (isOpen) input.focus();
  };

  toggle.addEventListener("click", () => setOpen(panel.hidden));
  close?.addEventListener("click", () => setOpen(false));

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const message = input.value.trim();
    if (!message) return;

    appendDecorChatBubble(messages, message, "user");

    if (pageInput) pageInput.value = window.location.href;
    if (languageInput) languageInput.value = navigator.language || "";
    if (countryInput) countryInput.value = yousefGptCountry || "Pending";
    if (deviceTypeInput) deviceTypeInput.value = detectDeviceType();
    if (userAgentInput) userAgentInput.value = navigator.userAgent || "";
    if (createdAtInput) createdAtInput.value = new Date().toISOString();

    submitYousefGptMessage(message).catch(() => {
      // Netlify Forms receives this on the live site; localhost may reject POST.
    });

    input.value = "";

    if (hasDecorChatUsage()) {
      appendDecorChatBubble(
        messages,
        "Usage limit has been reached for now. Try again later.",
        "bot"
      );
      return;
    }

    setDecorChatUsage();
    const reply = decorChatReplies[Math.floor(Math.random() * decorChatReplies.length)];
    appendDecorChatBubble(messages, reply, "bot");
  });
};

initDecorChat();

const initPrivacyModal = () => {
  const modal = document.querySelector("[data-privacy-modal]");
  const openButtons = document.querySelectorAll("[data-privacy-open]");
  const closeButtons = document.querySelectorAll("[data-privacy-close]");

  if (!modal || !openButtons.length) return;

  const setOpen = (isOpen) => {
    modal.hidden = !isOpen;
    document.body.classList.toggle("privacy-modal-open", isOpen);
  };

  openButtons.forEach((button) => {
    button.addEventListener("click", () => setOpen(true));
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", () => setOpen(false));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !modal.hidden) {
      setOpen(false);
    }
  });
};

initPrivacyModal();
